// apps/account-portal/src/stores/wishlistStore.ts
import { wishlistApi } from '../services/api';
import { createFeedStore } from '@redpanda/utils';

/** PENDING 待評估 → IN_PROGRESS 開發中（可略過）→ COMPLETED 已完成／DECLINED 不採用 */
export type WishlistStatus = 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'DECLINED';
export const WISHLIST_STATUSES: WishlistStatus[] = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'DECLINED'];

export interface WishlistPost {
  id: string;
  /** 是不是自己發的（後端判斷；公開 API 不回傳作者 id） */
  isMine: boolean;
  authorName: string;
  title: string;
  content: string;
  status: WishlistStatus;
  statusChangedAt: string | null;
  voteCount: number;
  userHasVoted: boolean;
  adminReply: string | null;
  adminReplyAt: string | null;
  createdAt: string;
}

/** 預設依票數排序（最多人要的在前） */
export const useWishlistStore = createFeedStore<WishlistPost>('wishlist-feed', async ({ page, filter, q, sort }) => {
  const { data } = await wishlistApi.getPosts({ page, pageSize: 20, status: filter || undefined, q: q || undefined, sort });
  return data;
}, {}, { filters: WISHLIST_STATUSES });
